import React from "react";
import { Instagram, Facebook, Heart } from "lucide-react";

const SOCIAL_LINKS = [
  {
    name: "Instagram",
    handle: "@san_marino_market",
    url: "https://www.instagram.com/san_marino_market/",
    icon: Instagram,
    gradient: "from-pink-500 via-fuchsia-500 to-orange-400",
    shadow: "shadow-pink-500/40",
    testid: "social-instagram",
  },
  {
    name: "Facebook",
    handle: "San Marino Market",
    url: "https://www.facebook.com/profile.php?id=61589405427852",
    icon: Facebook,
    gradient: "from-blue-700 via-blue-600 to-sky-500",
    shadow: "shadow-blue-500/40",
    testid: "social-facebook",
  },
];

export default function SocialSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-12" data-testid="social-section">
      <div className="bg-gradient-to-br from-[#1d3d3a] via-[#244c48] to-[#0e2422] rounded-3xl p-8 md:p-12 relative overflow-hidden">
        {/* Decorative blobs */}
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-amber-400/20 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-orange-500/20 blur-3xl" />

        <div className="relative grid md:grid-cols-[1fr_auto] gap-8 items-center">
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-amber-400/20 border border-amber-400/30 text-amber-300 px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-widest mb-3">
              <Heart className="w-3 h-3 fill-amber-300" /> Community
            </div>
            <h2 className="text-3xl md:text-4xl font-black leading-tight">
              Seguici sui nostri <span className="text-amber-300">canali social</span>
            </h2>
            <p className="text-amber-50/80 mt-3 text-sm md:text-base max-w-xl leading-relaxed">
              Resta aggiornato sulle ultime novità, scopri annunci in evidenza, partecipa alle aste live e unisciti alla community sammarinese del marketplace.
            </p>
          </div>

          <div className="flex flex-col gap-3 w-full md:w-auto md:min-w-[280px]">
            {SOCIAL_LINKS.map((s) => {
              const Icon = s.icon;
              return (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={s.testid}
                  className={`group flex items-center gap-4 bg-gradient-to-r ${s.gradient} ${s.shadow} shadow-xl hover:shadow-2xl rounded-2xl px-5 py-4 transition-all hover:-translate-y-0.5 hover:scale-[1.02]`}
                >
                  <div className="w-12 h-12 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center shrink-0 group-hover:bg-white/25 transition-colors">
                    <Icon className="w-7 h-7 text-white" strokeWidth={2.2} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-white font-black text-base">{s.name}</div>
                    <div className="text-white/85 text-xs font-bold tracking-wide truncate">{s.handle}</div>
                  </div>
                  <div className="text-white/90 text-xs font-black uppercase tracking-wider shrink-0">
                    Segui →
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
